// ##############################
// // // LoginPage view styles
// #############################

import pink from "@material-ui/core/colors/pink";
import {
  cardTitle
} from "../../material-dashboard-pro-react.jsx";
import { shake } from 'react-animations';
import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx";

const loginPageStyle = {
    cardTitle: {
        ...cardTitle,
        color: "#FFFFFF"
    },
    textCenter: {
        textAlign: "center"
    },
    content: {
        overflowX: 'hidden',
        overflowY: 'scroll',
        WebkitOverflowScrolling: 'touch',
        zIndex: "4",
        height: '100vh',
        paddingTop: '10vh',
    },
    justifyContentCenter: {
        justifyContent: "center !important"
    },
    customButtonClass: {
        "&,&:focus,&:hover": {
            color: "#FFFFFF"
        },
        marginLeft: "5px",
        marginRight: "5px"
    },
    inputAdornment: {
        marginRight: "18px"
    },
    inputAdornmentIcon: {
        color: "#555"
    },
    cardHidden: {
        opacity: "0",
        transform: "translate3d(0, -60px, 0)"
    },
    cardHeader: {
        marginBottom: "20px"
    },
    socialLine: {
        padding: "0.9375rem 0"
    },
    '@keyframes shake': shake,
    cardShake: {
        animationName: 'shake',
        animationDuration: '1s',
    },
    wrapper: {
        position: 'relative',
        width: '100%',
    },
    buttonProgress: {
        color: pink[700],
        position: 'absolute',
        top: '20%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    bankIDProgress: {
        color: '#469CBE',
    },
    switch: {
        height: '0px'
    },
    margin: {
        margin: '5px',
    },
    cssLabel: {
        '&$cssFocused': {
            color: pink[500],
        },
    },
    cssFocused: {},
    cssUnderline: {
        '&:after': {
            borderBottomColor: pink[500],
        },
    },
    ...buttonStyle,
};

export default loginPageStyle;
